import styled from 'react-emotion'

const Overlay = styled('div')(({ z = 1 }) => ({
  label: 'Overlay',
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(255,255,255,0.5)',
  zIndex: z
}))
export default Overlay
